import { combineEpics, ofType } from 'redux-observable';
import { map, catchError, switchMap, takeUntil } from 'rxjs/operators';
import { createErrorStream } from 'common/store/error';

import {
  LOAD,
  CLEAR,
  loadSuccess,
  loadError,
} from './actions';

const loadDevice = (action, state, { deviceService }) => action.pipe(
  ofType(LOAD),
  switchMap(action$ => deviceService
    .getById(action$.deviceId)
    .pipe(
      map(loadSuccess),
      takeUntil(action.pipe(ofType(CLEAR))),
      catchError(createErrorStream(action$, loadError)),
    )),
);

export default combineEpics(
  loadDevice,
);
